module.exports = __webpack_public_path__ + "img/tsubasa_202412.d4517f6c.jpg";